module.exports = __webpack_public_path__ + "images/emails/bg-envelope-b-1014db8a.png";